import React, { useEffect, useMemo, useState } from 'react';
import api from '../../services/apiClient.ts';
import { toast } from 'react-toastify';
import { RefreshCw, Calendar, PlusCircle, X } from 'lucide-react'; // NEW

// ——— Helpers ———
const fmtNum = (n) => Number(n || 0).toLocaleString();
const todayStr = () => new Date().toISOString().slice(0,10); // YYYY-MM-DD
const pick = (obj, keys) => keys.reduce((o,k)=> (obj[k]!==undefined && (o[k]=obj[k]), o), {});
const API_BASE = "/v1";

export default function InstallmentsMovements() {
  // فلاتر
  const [df, setDf] = useState(todayStr());
  const [dt, setDt] = useState(todayStr());
  const [scope, setScope] = useState('active'); // active | all
  const [groupId, setGroupId] = useState('');
  const [travelerId, setTravelerId] = useState('');
  const [installmentID, setInstallmentsID] = useState('');
  const [groupName, setGroupName] = useState('');     // بحث نصّي اختياري
  const [travelerName, setTravelerName] = useState(''); // بحث نصّي اختياري

  // بيانات الكومبو
  const [groups, setGroups] = useState([]);
  const [travelers, setTravelers] = useState([]);

  // جدول الحركات
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState('');

  // ترقيم
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(20);
  const [lastPage, setLastPage] = useState(1);
  const [total, setTotal] = useState(0);

  // ترتيب
  const [sort, setSort] = useState('updated_at');
  const [dir, setDir] = useState('desc');

  const tenant = useMemo(() => localStorage.getItem('tenant') || 'default-tenant-1', []);
  const branch = useMemo(() => localStorage.getItem('branch_id') || '1', []);


  // تثبيت الهيدرز لكل طلب
  useEffect(() => {
    const id = api.interceptors.request.use((config) => {
      const token = localStorage.getItem('auth_token');
      if (token) config.headers.Authorization = `Bearer ${token}`;
      config.headers['X-Tenant'] = tenant;
      config.headers['X-Branch'] = branch;
      return config;
    });
    return () => api.interceptors.request.eject(id);
  }, [tenant, branch]);

  // جلب الكومبوات
  const fetchCombos = async () => {
    try {
      const params = { scope };
      if (scope === 'active') {
        params.df = df;
        params.dt = dt;
      }
      const resp = await api.get('/v1/installmentsQuerycombos', { params });
      setGroups(resp?.data?.groups || []);
      setTravelers(resp?.data?.travelers || []);
    } catch (e) {
      console.error(e);
    }
  };
  
  // 🔧 helper: حوّل datetime-local إلى "YYYY-MM-DD HH:mm:ss"
  const toSqlDateTime = (v) => {
    if (!v) return null; // v مثل "2025-11-09T14:05"
    return v.replace('T', ' ') + ':00';
  };

  const toDatetimeLocal = (dateString) => {
    if (!dateString) return '';

    const d = new Date(dateString);
    if (isNaN(d)) return '';

    const pad = (n) => n.toString().padStart(2, '0');

    const yyyy = d.getFullYear();
    const mm   = pad(d.getMonth() + 1);
    const dd   = pad(d.getDate());
    const hh   = pad(d.getHours());
    const min  = pad(d.getMinutes());

    return `${yyyy}-${mm}-${dd}T${hh}:${min}`;
  }; 

    // NEW: حالة المودال + حقول الإدخال
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [amount, setAmount] = useState('');
  const [traveler_name, settraveler_name] = useState('');
  const [notes, setNotes] = useState('');
  const [dtSave , setDtSave] = useState(''); // datetime-local
  const [saving, setSaving] = useState(false);    

  // جلب الحركات
  const fetchMovements = async () => {
    setLoading(true); setErr('');
    try {
      const params = {
        df, dt, sort, dir, per_page: perPage, page,
        ...pick({ group_id: groupId || undefined, traveler_id: travelerId || undefined }, ['group_id','traveler_id'])
      };
      // بحث نصّي اختياري
      if (groupName.trim()) params.group_name = groupName.trim();
      if (travelerName.trim()) params.traveler_name = travelerName.trim();

      const resp = await api.get('/v1/installmentsQuery', { params });
      // استجابة اللارافيل: وضعنا كل الـ paginator داخل data
      const payload = resp?.data?.data;
      const items   = payload?.data || []; // الصفوف
      setRows(items);
      setPage(payload?.current_page || 1);
      setPerPage(payload?.per_page || 20);
      setLastPage(payload?.last_page || 1);
      setTotal(payload?.total || items.length);
    } catch (e) {
      setErr(e?.response?.data?.message || e.message || 'Network error');
      setRows([]);
      setLastPage(1); setTotal(0);
    } finally {
      setLoading(false);
    }
  };

  // أول تحميل: كومبو + بيانات اليوم
  useEffect(() => { fetchCombos(); fetchMovements(); /* eslint-disable-next-line */ }, []);
  // إعادة تحميل الكومبو عند تغيير النطاق/التواريخ
  useEffect(() => { fetchCombos(); /* eslint-disable-next-line */ }, [scope, df, dt]);
  // إعادة تحميل الجدول عند تغيير الصفحة/الفرز/الحجم
  useEffect(() => { fetchMovements(); /* eslint-disable-next-line */ }, [page, perPage, sort, dir]);

  const applyFilters = () => { setPage(1); fetchMovements(); };
  const resetFilters = () => {
    setGroupId(''); setTravelerId('');
    setGroupName(''); setTravelerName('');
    setDf(todayStr()); setDt(todayStr());
    setScope('active');
    setPage(1); setPerPage(20); setSort('updated_at'); setDir('desc');
    fetchCombos();
    fetchMovements();
  };

  const toggleOrder = (col) => {
    if (sort === col) setDir(dir === 'asc' ? 'desc' : 'asc');
    else { setSort(col); setDir('asc'); }
  };

  

    // NEW: افتح المودال
  const openInstallmentModal = async (row) => {
    try {
      const resp1 = await api.get(`/v1/installmentsQuery/by-entry/${row.id}`, {
        params: { scope }, // إذا محتاج تبعث سكوب
      });

      setSelectedRow(row);  
      const inst = resp1?.data?.data?.installment;

      settraveler_name(inst?.traveler_name ?? '');
      setAmount(inst?.amount ?? 0);
      setNotes(inst?.notes ?? '');
      setDtSave(toDatetimeLocal(inst?.updated_at ?? null));

      setModalOpen(true);
    } catch (e) {
      console.error(e);
    } 
  };

  async function remove(id){
    if (!window.confirm("حذف هذا القسط؟")) return;
    try{
      await api.delete(`${API_BASE}/installments/${id}`);
      toast.success("تم الحذف");
      fetchMovements();
    }catch(e){
      console.error(e);
      toast.error(e?.response?.data?.message || "فشل الحذف");
    }
  }  

    // NEW: حفظ القسط
  const saveInstallment = async () => {
    if (!selectedRow) return;

    const id       = selectedRow.id;
    const tenant   = localStorage.getItem('tenant')    || 'default-tenant-1';
    const branchId = localStorage.getItem('branch_id') || '1';

    // Basic validation
    if (!amount || Number(amount) <= 0) {
      alert('أدخل مبلغ صحيح.');
      return;
    }

    if (!dtSave) {
      alert('اختر تاريخ ووقت.');
      return;
    }

    // تجهيز الداتا التي تريد تغييرها فقط
    const payload = {
      amount: Number(amount),
      notes: notes || null,
      updated_at: toSqlDateTime(dtSave),  // <-- مهم
    };

    setSaving(true);

    try {
      await api.put(`/v1/installments/${id}`, payload, {
        headers: {
          'X-Tenant': tenant,
          'X-Branch': branchId,
          'Accept': 'application/json',
        }
      });

      setModalOpen(false);
      await fetchMovements();
      toast.success('تم الحفظ ✨');
    } catch (e) {
      console.error(e);
      toast.error(e?.response?.data?.message || 'خطأ أثناء الحفظ');
    } finally {
      setSaving(false);
    }
  };
  



  return (
    <div className="w-full mx-auto py-8 px-4 sm:px-6 lg:px-8">
      <h1 className="text-2xl font-bold mb-4">حركات الأقساط</h1>

      {/* فلاتر */}
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-4 mb-6">
        <div className="grid grid-cols-1 md:grid-cols-6 gap-3">
          {/* نطاق البيانات */}
          <div className="md:col-span-1">
            <label className="block text-sm mb-1">النطاق</label>
            <select
              value={scope}
              onChange={(e)=>setScope(e.target.value)}
              className="w-full border rounded px-2 py-2"
            >
              <option value="active">نشط (خلال المدة)</option>
              <option value="all">الكل</option>
            </select>
          </div>

          {/* تاريخ من/إلى */}
          <div>
            <label className="block text-sm mb-1">من تاريخ</label>
            <input type="date" value={df} onChange={(e)=>setDf(e.target.value)} className="w-full border rounded px-2 py-2" />
          </div>
          <div>
            <label className="block text-sm mb-1">إلى تاريخ</label>
            <input type="date" value={dt} onChange={(e)=>setDt(e.target.value)} className="w-full border rounded px-2 py-2" />
          </div>

          {/* كومبو المجموعة */}
          <div>
            <label className="block text-sm mb-1">المجموعة</label>
            <select
              value={groupId}
              onChange={(e)=>setGroupId(e.target.value)}
              className="w-full border rounded px-2 py-2"
            >
              <option value="">الكل</option>
              {groups.map(g => (
                <option key={g.id} value={g.id}>{g.name}</option>
              ))}
            </select>
          </div>

          {/* كومبو المسافر */}
          <div>
            <label className="block text-sm mb-1">المسافر</label>
            <select
              value={travelerId}
              onChange={(e)=>setTravelerId(e.target.value)}
              className="w-full border rounded px-2 py-2"
            >
              <option value="">الكل</option>
              {travelers.map(t => (
                <option key={t.id} value={t.id}>{t.name}</option>
              ))}
            </select>
          </div>

          {/* بحث نصّي اختياري */}
          <div className="md:col-span-2">
            <label className="block text-sm mb-1">بحث بالاسم (مجموعة)</label>
            <input
              type="text"
              value={groupName}
              onChange={(e)=>setGroupName(e.target.value)}
              className="w-full border rounded px-2 py-2"
              placeholder="جزئي أو كامل"
            />
          </div>
          <div className="md:col-span-2">
            <label className="block text-sm mb-1">بحث بالاسم (مسافر)</label>
            <input
              type="text"
              value={travelerName}
              onChange={(e)=>setTravelerName(e.target.value)}
              className="w-full border rounded px-2 py-2"
              placeholder="جزئي أو كامل"
            />
          </div>

          {/* أزرار */}
          <div className="md:col-span-2 flex items-end gap-2">
            <button onClick={applyFilters} className="px-4 py-2 rounded bg-blue-600 hover:bg-blue-700 text-white">
              تطبيق الفلاتر
            </button>
            <button onClick={resetFilters} className="px-4 py-2 rounded bg-gray-100 hover:bg-gray-200">
              إعادة ضبط
            </button>
          </div>
        </div>
      </div>

      {/* أخطاء */}
      {err && (
        <div className="mb-4 text-red-600">{err}</div>
      )}

      {/* جدول */}
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow">
        <div className="app-table-wrap">
        <table className="app-table min-w-full">
          <thead className="bg-gray-50 dark:bg-gray-700">
            <tr>
              <Th label="المعرف" col="id" sort={sort} dir={dir} onSort={toggleOrder} />
              <Th label="المجموعة" col="group_name" onSort={toggleOrder} sort={sort} dir={dir} noSort />
              <Th label="المسافر" col="traveler_name" onSort={toggleOrder} sort={sort} dir={dir} noSort />
              <Th label="المبلغ" col="amount" sort={sort} dir={dir} onSort={toggleOrder} align="right" />
              <Th label="ملاحظات" col="notes" noSort />
              <Th label="تاريخ الحركة" col="updated_at" sort={sort} dir={dir} onSort={toggleOrder} />
              <Th label="تعديل"  noSort />              
            </tr>
          </thead>
          <tbody className="divide-y">
            {loading ? (
              <tr><td colSpan={6} className="p-4 text-center text-gray-500">جاري الجلب...</td></tr>
            ) : rows.length === 0 ? (
              <tr><td colSpan={6} className="p-4 text-center text-gray-500">لا توجد بيانات</td></tr>
            ) : (
              rows.map(r => (
                <tr key={r.id} className="hover:bg-gray-50">
                  <td className="p-3 text-sm whitespace-nowrap">{r.id}</td>
                  <td className="p-3 text-sm whitespace-nowrap">{r.group_name}</td>
                  <td className="p-3 text-sm whitespace-nowrap">{r.traveler_name}</td>
                  <td className="p-3 text-sm text-right font-semibold whitespace-nowrap">{fmtNum(r.amount)}</td>
                  <td className="p-3 text-sm max-w-[180px] truncate" title={r.notes || ''}>{r.notes || ''}</td>
                  <td className="p-3 text-sm whitespace-nowrap">
                    {r.updated_at ? new Date(r.updated_at).toLocaleString() : ''}
                  </td>
                    <div className="flex gap-3 justify-end">
                      <button onClick={()=>openInstallmentModal(r)} className="text-indigo-600 hover:text-indigo-800">تعديل</button>
                      <button onClick={()=>remove(r.id)} className="text-red-600 hover:text-red-800">حذف</button>
                    </div>                                                    
                </tr>
              ))
            )}
          </tbody>
        </table>
        </div>
      </div>

      {/* ترقيم */}
      <div className="mt-4 flex items-center justify-between">
        <div className="text-sm text-gray-600">
          إجمالي: {fmtNum(total)} | صفحة {page} من {lastPage}
        </div>
        <div className="flex items-center gap-2">
          <button
            className="px-3 py-1 rounded border"
            onClick={()=> setPage((p)=> Math.max(1, p-1))}
            disabled={page <= 1 || loading}
          >
            السابق
          </button>
          <button
            className="px-3 py-1 rounded border"
            onClick={()=> setPage((p)=> Math.min(lastPage, p+1))}
            disabled={page >= lastPage || loading}
          >
            التالي
          </button>
          <select
            className="px-2 py-1 border rounded"
            value={perPage}
            onChange={(e)=> { setPerPage(Number(e.target.value)); setPage(1); }}
          >
            {[10,20,50,100].map(n => <option key={n} value={n}>{n}/صفحة</option>)}
          </select>
        </div>
      </div>

      {/* NEW: المودال */}
      {modalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
          <div className="w-full max-w-md bg-white dark:bg-gray-800 rounded-xl shadow-2xl">
            <div className="flex items-center justify-between px-4 py-3 border-b dark:border-gray-700">
              <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100">استلام قسط</h3>
              <button onClick={() => setModalOpen(false)} className="p-1 rounded hover:bg-gray-100 dark:hover:bg-gray-700">
                <X className="w-5 h-5 text-gray-600 dark:text-gray-300" />
              </button>
            </div>
            {/* الاسم */}
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                الاسم
              </label>
              <input
                value={traveler_name}
                disabled
                onChange={(e) => settraveler_name(e.target.value)}
                className="w-full px-3 py-2 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 focus:ring-2 focus:ring-primary-500 focus:border-primary-500 text-right"
              />
            </div>
            
            <div className="px-4 py-4 space-y-4">
              {/* تاريخ ووقت */}
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                  التاريخ والوقت
                </label>
                <input
                  type="datetime-local"
                  value={dtSave}
                  onChange={(e) => setDtSave(e.target.value)}
                  className="w-full px-3 py-2 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
                />
              </div>

              {/* مبلغ */}
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                  المبلغ
                </label>
                <input
                  type="number"
                  min="0"
                  step="0.01"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                  className="w-full px-3 py-2 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 focus:ring-2 focus:ring-primary-500 focus:border-primary-500 text-right"
                  placeholder="0.00"
                />
              </div>

              {/* ملاحظات */}
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                  ملاحظات
                </label>
                <textarea
                  rows={3}
                  value={notes}
                  onChange={(e) => setNotes(e.target.value)}
                  className="w-full px-3 py-2 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
                  placeholder="مثال: الدفعة الأولى"
                />
              </div>
            </div>

            <div className="flex items-center justify-end gap-2 px-4 py-3 border-t dark:border-gray-700">
              <button
                onClick={() => setModalOpen(false)}
                className="px-4 py-2 rounded-lg bg-gray-100 hover:bg-gray-200 dark:bg-gray-700 dark:hover:bg-gray-600 text-gray-800 dark:text-gray-100"
              >
                إلغاء
              </button>
              <button
                onClick={saveInstallment}
                disabled={saving}
                className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-blue-600 hover:bg-blue-700 disabled:bg-blue-400 text-white font-semibold"
              >
                <PlusCircle className="w-4 h-4" />
                {saving ? 'جاري الحفظ...' : 'حفظ القسط'}
              </button>
            </div>
          </div>
        </div>
      )}      






    </div>
  );
}

// رأس عمود قابل للفرز
function Th({ label, col, sort, dir, onSort, align, noSort }) {
  const isActive = sort === col;
  const caret = isActive ? (dir === 'asc' ? '▲' : '▼') : '';
  const cls = 'px-3 py-2 text-xs font-semibold whitespace-nowrap ' + (align === 'right' ? 'text-right' : 'text-left');

  return (
    <th className={cls}>
      {noSort ? (
        <span>{label}</span>
      ) : (
        <button onClick={()=>onSort(col)} className="inline-flex items-center gap-1">
          <span>{label}</span>
          <span className="opacity-60">{caret}</span>
        </button>
      )}
    </th>
  );
}
